import { FetchResult, MutationFunctionOptions, useMutation } from '@apollo/client';
import { useCallback } from 'react';

import {
  downloadFileByUrl,
  evictCache,
  GET_AND_SAVE_RD_PROJECTS_REPORT_SIGNED_URL,
  GetAndSaveRdProjectsReportSignedUrlMutation,
  GetAndSaveRdProjectsReportSignedUrlMutationVariables,
} from '@neo.tax/shared';

export const useGetAndSaveRdProjectsReportSignedUrl = (): {
  getAndSaveRdProjectsReportSignedUrl: (
    options?: MutationFunctionOptions<
      GetAndSaveRdProjectsReportSignedUrlMutation,
      GetAndSaveRdProjectsReportSignedUrlMutationVariables
    >,
  ) => Promise<FetchResult<GetAndSaveRdProjectsReportSignedUrlMutation>>;
  loading: boolean;
  called: boolean;
  downloadRdProjectsReport: (fiscalYearId: string) => Promise<void>;
} => {
  const [getAndSaveRdProjectsReportSignedUrl, { called, loading }] = useMutation<
    GetAndSaveRdProjectsReportSignedUrlMutation,
    GetAndSaveRdProjectsReportSignedUrlMutationVariables
  >(GET_AND_SAVE_RD_PROJECTS_REPORT_SIGNED_URL, {
    update: (cache) => {
      evictCache(cache, ['getBackgroundOperations']);
    },
  });

  const downloadRdProjectsReport = useCallback(
    async (fiscalYearId: string): Promise<void> => {
      const { data } = await getAndSaveRdProjectsReportSignedUrl({ variables: { fiscalYearId } });
      const signedUrl = data?.getAndSaveRdProjectsReportSignedUrl.signedUrl;
      if (!signedUrl) {
        return;
      }
      // The file name here is irrelevant. The file will be downloaded as the original name uploaded to GCP Cloud Storage.
      downloadFileByUrl(signedUrl, 'rd-projects-report.xlsx');
    },
    [getAndSaveRdProjectsReportSignedUrl],
  );

  return {
    getAndSaveRdProjectsReportSignedUrl,
    loading,
    called,
    downloadRdProjectsReport,
  };
};
